/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/ends_with.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns a boolean that indicates whether a keyword string ends with another string.',
  examples: [
    'FROM employees\n| KEEP last_name\n| EVAL ln_E = ENDS_WITH(last_name, "d")',
  ],
  params: {
    str: 'String expression. If `null`, the function returns `null`.',
    suffix: 'String expression. If `null`, the function returns `null`.',
  },
};

export default docs;
